// src/pages/History/EarlyModern/SpanishPortugueseColonization.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/Early_Modern_Period_-_Spanish_and_Portuguese_Colonization.png';

function HistoryPageSpanishPortugueseColonization() {
  return (
    <TopicPage
      topicKey="Spanish and Portuguese Colonization"
      title="History: Spanish and Portuguese Colonization"
      backgroundImage={bg}
      startRoute="/History-Spanish-Portuguese-Colonization-Go"
      scrollLabels={[
        "Conquest of the Americas",
        "Encomienda and Plantation Systems",
        "Cultural Exchange and Legacy",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageSpanishPortugueseColonization;
